import React from 'react';
import styles from './Checkbox2.module.scss';

type Props = {
  type?: string;
  name: string;
  value: string;
  label?: string;
  className?: string;
  bgImage?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
};

const Checkbox2 = React.forwardRef<HTMLInputElement, Props>((props, ref): JSX.Element => {
  const {
    type = "checkbox",
    name,
    value,
    label,
    className,
    bgImage,
    onChange,
    checked,
    defaultChecked,
    disabled,
    children,
    ...other
  } = props;

  return (
    // <div className={clsx(styles.container, className)}>
    <label className={styles.label}>
      <input
        ref={ref}
        type={type}
        name={name}
        value={value}
        className={styles.input}
        onChange={onChange}
        defaultChecked={defaultChecked}
        disabled={disabled}
        checked={checked}
        {...other}
      />
      <div className={styles.box} style={{
        backgroundImage: `url(${bgImage})`,
      }} />
      <p className={styles.text}>
        {children}
      </p>
    </label>
  );
});

export default React.memo(Checkbox2);